import { render, staticRenderFns } from "./DeviceFaultType.vue?vue&type=template&id=87a17d98&scoped=true"
import script from "./DeviceFaultType.vue?vue&type=script&lang=js"
export * from "./DeviceFaultType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a17d98",
  null
  
)

export default component.exports